import { RefreshCw } from 'lucide-react';
import { Button } from '../../components/Button';
import { Heading } from '../../components/Heading';
import { ClinicianInsights } from './clinician-insights/ClinicianInsights';
import { useClinicianDashboardData } from './hooks/useClinicianDashboardData';
import { RecentPatientsList } from './recent-patients/RecentPatientsList';
import { RecentPatientsListSkeleton } from './recent-patients/RecentPatientsListSkeleton';
import { RecentSessionsList } from './recent-sessions/RecentSessionsList';
import { RecentSessionsListSkeleton } from './recent-sessions/RecentSessionsListSkeleton';

export interface ClinicianDashboardContentProps {
  dateRange: [Date, Date] | null;
}

export function ClinicianDashboardContent({ dateRange }: ClinicianDashboardContentProps) {
  const {
    data: { patients, sessions, totalSessions, insights },
    isLoading,
    isFetching,
    hasMoreSessions,
    fetchNextPage
  } = useClinicianDashboardData({ dateRange });

  return (
    <div className="flex flex-col gap-5">
      <ClinicianInsights dateRange={dateRange} insights={insights} isLoading={isLoading} />

      <Heading size="m">Recent Patients {!isLoading && <span className="md:hidden">({patients.length})</span>}</Heading>
      {isLoading ? <RecentPatientsListSkeleton /> : <RecentPatientsList patients={patients} />}

      <Heading size="m">Recent Sessions {!isLoading && <span className="md:hidden">({totalSessions})</span>}</Heading>
      {isLoading ? <RecentSessionsListSkeleton /> : <RecentSessionsList sessions={sessions} patients={patients} />}

      {!isLoading && hasMoreSessions && (
        <div className="flex items-center justify-center">
          <Button variant="transparent" icon={RefreshCw} size="m" onClick={fetchNextPage} isLoading={isFetching}>
            Load more
          </Button>
        </div>
      )}
    </div>
  );
}
